/* eslint-disable */
// NOTE :: DO NOT EDIT :: this file is automatically generated by generate-environment-variables.js node script

export const envVariables: { [key: string]: string } = {
  CIRCLE_TAG: 'prod-purposeful-v129',
  PROJECT: 'purposeful',
  PRODUCT: 'purposeful',
};
export const latestTag: string = 'prod-purposeful-v129';
export const latestVersion: string = 'v129';
export const versions: { app: { [key: string]: string }, branch: string, npm_version: string, revision: string } = {
  app: {
    purposeful: '9.0.0',
    insightful: '3.1.2',
  },
  branch: 'HEAD',
  npm_version: '167.0.0',
  revision: 'cc35618c3',
};
/* eslint-enable */
